"use client";
import { FormControl, FormHelperText, InputLabelProps } from "@mui/material";
import { ReactNode, forwardRef, memo } from "react";
import {
  Control,
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
} from "react-hook-form";
import { AppOptionType } from "@/models";
import AppFromLabelField from "./AppFromLabelField";
import AppFormControlLoading, {
  TypeInputLoading,
} from "./AppFormControlLoading";
import AppRadioGroup, { AppRadioGroupProps } from "../AppRadioGroup";

const AppFormControlRadio = forwardRef(
  <T extends FieldValues>(
    {
      control,
      name,
      options = [],
      controlProps,
      onChangeValueForm,
      label,
      radioGroupProps,
      labelProps,
      classNameContainer,
      isLoading = false,
      helper,
    }: AppFormControlRadioProps<T>,
    ref: React.Ref<unknown>
  ) => {
    return (
      <AppFromLabelField
        label={label}
        labelProps={{
          ...labelProps,
        }}
        className={classNameContainer}
        required={labelProps?.required}
        helper={helper}
      >
        {isLoading && (
          <AppFormControlLoading
            count={3}
            typeInputLoading={TypeInputLoading.Radio}
          />
        )}
        {!isLoading && (
          <Controller
            name={name}
            control={control}
            render={({
              field: { onChange, ...otherFieldProps },
              fieldState: { error: errorField },
            }) => (
              <FormControl {...otherFieldProps} error={!!errorField}>
                <AppRadioGroup
                  options={options}
                  onChange={(_, value) => {
                    onChange(value);
                    if (onChangeValueForm instanceof Function)
                      onChangeValueForm(value);
                  }}
                  {...otherFieldProps}
                  {...radioGroupProps}
                />
                {errorField && (
                  <FormHelperText>{errorField?.message}</FormHelperText>
                )}
              </FormControl>
            )}
            {...controlProps}
          />
        )}
      </AppFromLabelField>
    );
  }
);

type AppFormControlRadioProps<T extends FieldValues> = {
  isLoading?: boolean;
  control: Control<any>;
  name: FieldPath<T>;
  options: Array<AppOptionType>;
  controlProps?: Omit<ControllerProps, "render" | "name" | "control">;
  // formControlLabelProps?: Omit<
  //   FormControlLabelProps,
  //   "value" | "label" | "control"
  // >;
  label?: string | ReactNode;
  labelProps?: InputLabelProps;
  radioGroupProps?: Omit<AppRadioGroupProps, "options">;
  onChangeValueForm?: (value?: string | number) => void;
  classNameContainer?: string;
  helper?: string | ReactNode;
};
AppFormControlRadio.displayName = "AppFormControlRadio";
export default memo(AppFormControlRadio);
